module.exports = "/images/procedures-completed.0688de57bdee5881be06f25504bd3b6e.svg";